import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: false
})
export class FooterComponent {
  year = new Date().getFullYear();
  /** The visitor's language (the legal links read it). */
  readonly isAr = ((localStorage.getItem('lang') as 'ar' | 'en') || 'ar') === 'ar';
}
